<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Настройка показателей</p>
      <template v-if="isAccessAllowed">
        <div class="mb-16">
          <ButtonComponent mod="gradient-bg" @click="updateIndicators()" :disabled="isSaving">
            Сохранить
          </ButtonComponent>
        </div>
        <div class="table-container mb-16 js-table-arrow">
          <table class="stockTable">
            <thead>
              <tr>
                <th>Название индикатора</th>
                <th>Показывать больше информации</th>
              </tr>
            </thead>
            <tbody v-if="items?.length && !isLoading">
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.name }}</td>
                <td>
                  <CheckboxInput v-model="item.moreInfoVisible" />
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isLoading">
              <tr>
                <td class="text-center" colspan="5">Загрузка...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-center" colspan="5">Нет данных.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import API from '../api/indicatorVisibility';

  const PERMISSIONS = {
    edit: Constants.Permissions.IndicatorVisibilityEdit,
  };

  export default {
    name: 'IndicatorVisibility',
    components: { CheckboxInput, ButtonComponent },
    mixins: [security],
    data() {
      return {
        items: [],

        isLoading: false,
        isSaving: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.edit);
      if (!isAllowed) return;
      this.loadPage();
    },
    methods: {
      loadPage() {
        this.isLoading = true;
        API.search()
          .then((response) => {
            this.items = response.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      updateIndicators() {
        this.isSaving = true;
        API.update(this.items).then(() => {
          this.isSaving = false;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .checkboxInput::v-deep input[type='checkbox'] {
    position: relative !important;
    width: 20px !important;
    height: 20px !important;
    left: 0 !important;
    top: 0 !important;
    z-index: 0 !important;
    margin: 0 auto;
  }
</style>
